export default class ResponseHandlerChain {
  constructor (handler) {
    this.handler = handler;
    this.executor = null;
  }

  setExecutor (executor) {
    this.executor = executor;
    return this;
  }

  passRequest (...args) {
    const isHandle = this.handler(...args);

    if (!isHandle) {
      return this.executor && this.executor.passRequest(...args);
    }

    return isHandle;
  }
}
